export enum HabitudeCuissonEnum {
  HABITUDE_CUISSON_CUISINEZ_SOUVENT = 'HABITUDE_CUISSON_CUISINEZ_SOUVENT',
  HABITUDE_CUISSON_CUISINEZ_REGULIEREMENT = 'HABITUDE_CUISSON_CUISINEZ_REGULIEREMENT',
  HABITUDE_CUISSON_CUISINEZ_RAREMENT = 'HABITUDE_CUISSON_CUISINEZ_RAREMENT',
}
